import ApiService from './ApiService'

/**
 * Serviço específico para APIs relacionadas ao Fashion Orders
 * Todas as requisições passam pelo gateway e incluem automaticamente o tenantId via interceptor
 */
class FashionApiService {
  private static readonly BASE_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders`

  /**
   * GET request para endpoints do fashion
   */
  static async get(endpoint: string, params?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.get(url, params, config)
  }

  /**
   * POST request para endpoints do fashion
   */
  static async post(endpoint: string, data?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.post(url, data, config)
  }

  /**
   * PUT request para endpoints do fashion
   */
  static async put(endpoint: string, data?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.put(url, data, config)
  }

  /**
   * PATCH request para endpoints do fashion
   */
  static async patch(endpoint: string, data?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.patch(url, data, config)
  }

  /**
   * DELETE request para endpoints do fashion
   */
  static async delete(endpoint: string, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.delete(url, config)
  }

  // Métodos específicos para Fashion Orders
  static async getFashionOrders() {
    const url = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-order/fashion-orders`
    return ApiService.get(url)
  }

  static async getFashionProducts(page: number, size: number, status?: boolean) {
    let endpoint = `/fashion-product/paginated?page=${page}&size=${size}`
    if (status !== undefined) {
      endpoint += `&status=${status}`
    }
    return this.get(endpoint)
  }

  static async updateFashionProduct(productId: number, data: any) {
    return this.put(`/fashion-product/${productId}`, data)
  }

  static async getFamilyColors(familyId: number) {
    return this.get(`/fashion-product/families/${familyId}/colors`)
  }

  static async searchFamilies(name: string) {
    return this.get(`/fashion-product/families?name=${encodeURIComponent(name)}`)
  }

  static async searchGroups(name: string) {
    return this.get(`/fashion-product/groups?name=${encodeURIComponent(name)}`)
  }

  static async getProductionOrders() {
    return this.get('/fashion-production-orders')
  }

  static async updateProductionOrder(orderId: number, data: any) {
    return this.patch(`/fashion-production-orders/${orderId}`, data)
  }

  static async getUsers(role?: string) {
    const endpoint = role ? `/users?role=${encodeURIComponent(role)}` : '/users'
    return this.get(endpoint)
  }

  static async getStages() {
    return this.get('/stages')
  }

  static async getPaymentConditions() {
    return this.get('/fashion-order/payment-conditions')
  }

  static async getShippingTypes() {
    return this.get('/fashion-order/shipping-types')
  }
}

export default FashionApiService